import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import TrailsApi from '../../../Logicas/TrailsApi';
import TrailCreateInitial from './TrailCreateInitial';
import TrailCoursesManager from './TrailCoursesManager';
import { withRouter } from 'react-router';

import * as S from './NewTrailStyles';
import TrailsList from './TrailsList';

class NewTrail extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: 'geral',
      removedCourseIds: [],
      addedCourseIds: [],
      trailId: null
    };

    // this.saveTrail = this.saveTrail.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.handleAddAndRemoveCourses = this.handleAddAndRemoveCourses.bind(this);
    this.loadTrailFromUrl = this.loadTrailFromUrl.bind(this);
  }

  // saveTrail(values) {
  //   if (!values.image) {
  //     this.props.showError();
  //     return;
  //   }

  //   this.props.createTrail(values);
  // }

  changeTab(tab) {
    this.setState({ activeTab: tab });
  }

  handleAddAndRemoveCourses() {
    const { currentTrail } = this.props;
    const { removedCourseIds, addedCourseIds } = this.state;

    if (!currentTrail) return;

    addedCourseIds.length &&
      this.props.addCourseToTrail(currentTrail.id, addedCourseIds);
    removedCourseIds.length &&
      this.props.removeCourseFromTrail(currentTrail.id, removedCourseIds);

    // addedCourseIds.length && this.props.addCourseToTrail(2, addedCourseIds);
    // removedCourseIds.length &&
    //   this.props.removeCourseFromTrail(2, removedCourseIds);
  }

  // componentDidMount() {
  //   const search = window.location.search;
  //   const params = new URLSearchParams(search);
  //   const trailId = params.get('id');

  //   if (trailId) {
  //     this.setState({ trailId });
  //     this.props.getCurrentTrail(trailId);
  //   } else {
  //     this.props.clearCurrentTrail();
  //   }
  // }

  // componentDidUpdate() {
  //   const search = window.location.search;
  //   const params = new URLSearchParams(search);
  //   const trailId = params.get('id');

  //   if (trailId) {
  //     this.setState({ trailId });
  //   }
  // }

  loadTrailFromUrl = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const trailId = params.get('id');

    if (trailId) {
      this.setState({ trailId });
      this.props.getCurrentTrail(trailId);
    } else {
      this.setState({ trailId: null });
      this.props.clearCurrentTrail();
    }
  };

  componentDidMount() {
    this.loadTrailFromUrl();
  }

  componentDidUpdate(prevProps) {
    if (window.location.search !== prevProps.location.search) {
      this.loadTrailFromUrl();
    }
  }

  renderMenu() {
    const { activeTab } = this.state;
    const { addCourseToTrail } = this.props;

    return (
      <S.Menu>
        <div style={{ display: 'flex', gap: '16px' }}>
          <S.MenuOption
            className={activeTab === 'geral' ? 'active' : ''}
            onClick={() => this.changeTab('geral')}
          >
            Geral
          </S.MenuOption>

          <S.MenuOption
            className={activeTab === 'cursos' ? 'active' : ''}
            onClick={() => this.changeTab('cursos')}
          >
            Cursos
          </S.MenuOption>
        </div>

        {activeTab === 'cursos' && (
          <div style={{ display: 'flex', gap: '16px' }}>
            <S.CoursesActions
              onClick={() => this.setState({ activeTab: 'geral' })}
            >
              Voltar
            </S.CoursesActions>
            <S.CoursesActions
              style={{ fontWeight: '500' }}
              save={true}
              onClick={this.handleAddAndRemoveCourses.bind(this)}
            >
              Salvar
            </S.CoursesActions>
          </div>
        )}
      </S.Menu>
    );
  }

  render() {
    const { activeTab, trailId } = this.state;
    const { currentTrail, params } = this.props;

    // const hasTrail =
    //   currentTrail && currentTrail.id !== undefined && currentTrail.id !== null;

    const hasTrail = Boolean(trailId);

    const onCoursesChange = ([availableCourseIds, selectedCourseIds]) =>
      this.setState({
        removedCourseIds: availableCourseIds,
        addedCourseIds: selectedCourseIds
      });

    return (
      <div>
        {hasTrail && this.renderMenu()}

        <div style={{ display: activeTab === 'geral' ? 'block' : 'none' }}>
          <TrailCreateInitial hasTrail={hasTrail} />
        </div>

        {hasTrail && (
          <div style={{ display: activeTab === 'cursos' ? 'block' : 'none' }}>
            <TrailCoursesManager
              trailId={trailId}
              onCoursesChange={onCoursesChange}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addCourseToTrail: (idTrail, idCourseList) => {
      dispatch(TrailsApi.addCourseToTrail(idTrail, idCourseList));
    },
    removeCourseFromTrail: (idTrail, idCourseList) => {
      dispatch(TrailsApi.removeCourseFromTrail(idTrail, idCourseList));
    },
    getCurrentTrail: (id) => {
      dispatch(TrailsApi.getCurrentTrail(id));
    },
    clearCurrentTrail: () => dispatch({ type: 'CLEAR_CURRENT_TRAIL' })
  };
};

export default withRouter(
  connect(
    (state) => ({
      currentTrail: state.trails && state.trails.currentTrail
    }),
    mapDispatchToProps
  )(NewTrail)
);

// let InitializeFromStateForm = reduxForm({
//   form: 'create_trail_form'
// })(NewTrail);

// InitializeFromStateForm = connect(
//   (state) => ({
//     alert: state.dialog,
//     currentTrail: state.trails && state.trails.currentTrail
//   }),
//   mapDispatchToProps
// )(InitializeFromStateForm);

// export default InitializeFromStateForm;
